<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue';

const props = defineProps({
  formData: {
    type: Object,
    required: true,
    default: () => ({
      patient: {
        agreements: {
          acknowledgementConsent: true,
          consentFinancial: true,
          consentForTreatment: true,
        },
      },
    }),
  },
});

const emit = defineEmits(['update:formData']);

const patientRegForm = ref({
  ...props.formData,
  patient: {
    ...props.formData.patient,
    agreements: {
      acknowledgementConsent: props.formData.patient.agreements?.acknowledgementConsent ?? true,
      consentFinancial: props.formData.patient.agreements?.consentFinancial ?? true,
      consentForTreatment: props.formData.patient.agreements?.consentForTreatment ?? true,
    },
  },
});

const updateForm = () => {
  emit('update:formData', patientRegForm.value);
};

watch(() => props.formData, (newFormData) => {
  patientRegForm.value = {
    ...newFormData,
    patient: {
      ...newFormData.patient,
      agreements: {
        acknowledgementConsent: newFormData.patient.agreements?.acknowledgementConsent ?? true,
        consentFinancial: newFormData.patient.agreements?.consentFinancial ?? true,
        consentForTreatment: newFormData.patient.agreements?.consentForTreatment ?? true,
      },
    },
  };
}, { deep: true });
</script>

<template>
  <div class="border border-gray-300 rounded-lg p-6 w-1/2 mx-auto">
    <h3 class="text-gray-600 font-medium mb-4">Agreement Acknowledgements</h3>
    <div class="space-y-4">
      <div class="flex items-center">
        <input
          type="checkbox"
          v-model="patientRegForm.patient.agreements.acknowledgementConsent"
          id="privacyPolicy"
          @input="updateForm"
          class="form-checkbox h-5 w-5 text-custom-yellow focus:ring-custom-yellow"
        />
        <label for="privacyPolicy" class="ml-3 text-gray-600"
          >Privacy Policy Acknowledgement</label
        >
      </div>

      <div class="flex items-center">
        <input
          type="checkbox"
          v-model="patientRegForm.patient.agreements.consentFinancial"
          @input="updateForm"
          id="financialResponsibility"
          class="form-checkbox h-5 w-5 text-custom-yellow focus:ring-custom-yellow"
        />
        <label for="financialResponsibility" class="ml-3 text-gray-600"
          >Financial Responsibility Agreement</label
        >
      </div>

      <div class="flex items-center">
        <input
          type="checkbox"
          v-model="patientRegForm.patient.agreements.consentForTreatment"
          id="consentForTreatment"
          @input="updateForm"
          class="form-checkbox h-5 w-5 text-custom-yellow focus:ring-custom-yellow"
        />
        <label for="consentForTreatment" class="ml-3 text-gray-600"
          >Consent for Treatment</label
        >
      </div>
    </div>
  </div>
</template>

<style scoped>
/* Add any additional styles if needed */
</style>